import moment from 'moment';
// eslint-disable-next-line import/extensions,import/no-unresolved
import WebCamModal from '../../../app/components/WebCamModal';
import Hint from '../../../app/components/hint/Hint.vue';
import QrCodeScanner from '../../../components/QrCodeScanner.vue';
import { checkDotDate, checkSoldOn, dotCodePattern, dotCodePattern2 } from './validation';

export default {
  props: ['id'],
  components: { WebCamModal, Hint, QrCodeScanner },
  data() {
    return {
      form: {
        status: null,
        warranty_number: null,
        dot_code: '',
        sold_on_local: null,
        has_replacement: null,
        product_id: null,
        type_id: null,
        category_id: null,
        speed: null,
        price: null,
        protector_mm: null,
        damage_type: null,
        expert_res: null,
        car_id: null,
        car_model_id: null,
        customer_last_name: null,
        customer_first_name: null,
        customer_middle_name: null,
        customer_phone_mobile_local: '',
        comment: null,
        /** фотки */

        cheque1: null,
        cheque2: null,
        passport_photo: null,
        blank_scan: null,
        dot: null,
        damage4: null,
        damage1: null,
        damage2: null,
        damage3: null,
        request_scan: null,
      },
      date: '',
      showPicker: false,
      isLoading: false,
      showHistory: false,
      valid: true,
      rules: {
        required: v => !!v || 'Обязательное поле',
        notNull: v => (v !== null && v !== undefined) || 'Обязательное поле',
        phone: v => (v && v.length && v.length >= 17) || 'Номер телефона заполнен не полностью',
        dot_code_pattern: v => (!!v && (!!v.match(dotCodePattern) || !!v.match(dotCodePattern2))) || 'Введите корректное значение',
        dot_code_date: v => checkDotDate(v, this.form.sold_on_local) <= 4 || 'С момента даты выпуска шины до момента продажи должно пройти не более 4-х лет',
        checkSoldOn: v => checkSoldOn(v) <= 1 || 'Расширенная Гарантия «САМУРАЙ» действует 1 год с момента покупки',
        file_size: v => !v || !v.size || v.size < 5242880 || 'Максимальный размер файла 5мб',
      },
      is_draft: false,
      cameraError: '',
      openModal: false,
      eventNameFile: '',
      ev: null,
      toolQR: false,
      replacement: [
        {
          text: 'Да',
          value: 1,
        },
        {
          text: 'Нет',
          value: 0,
        },
      ],
      scanQrCode: {
        openModal: false,
      },
      dotCodeTypeValue: [
        {
          text: 'Старый',
          value: 0,
        },
        {
          text: 'Новый',
          value: 1,
        },
      ],
      dotCodeType: 0,
    };
  },
  computed: {

    dotCodeMask() {
      return this.dotCodeType === 1 ? 'XXX XXXXXX ####' : 'XXXX-XXX####';
    },

    dotCodePlaceholder() {
      return this.dotCodeType === 1 ? '___ ______ ____' : '____-_______';
    },

    /** new methods */

    expertReses() {
      return this.$store.state.warranties.expertRes;
    },
    damageTypes() {
      return this.$store.state.warranties.damageTypes;
    },
    products() {
      return this.$store.state.warranties.products;
    },
    types() {
      return this.$store.state.warranties.types;
    },
    categories() {
      return this.$store.state.warranties.categories;
    },
    cars() {
      return this.$store.state.warranties.cars;
    },

    carsModels() {
      if (this.form.car_id && this.cars) {
        return this.cars.filter(el => +el.car_id === +this.form.car_id);
      }
      return this.cars;
    },

    disabledForm() {
      return this.form.id && this.form.status !== 'redo' && this.form.status !== 'draft';
    },

    isShowDraftButton() {
      return !this.form?.id || this.form?.confirm_status === 'draft';
    },


    user() {
      return this.$store.state.user;
    },
    loading() {
      return this.$store.state.loading;
    },
    minDate() {
      const date = new Date();
      date.setMonth(date.getMonth() - 12);
      return date.toISOString().substr(0, 10);
    },
    maxDate() {
      return new Date().toISOString().substr(0, 10);
    },
    device() {
      return this.devices.find(item => item.deviceId === this.deviceId);
    },
    // eslint-disable-next-line consistent-return
    phoneMask() {
      if (!this.form.customer_phone_mobile_local) {
        return '+7 (###) ###-####';
      }
      return this.form.customer_phone_mobile_local[0] === '8' ? '8 (###) ###-####' : '+7 (###) ###-####';
    },
  },
  methods: {
    /**
     * Получение продажи
     * @param qrcode
     */
    async detectQr(qrcode) {
      await this.$store.getters.axl.post('fns/api/tickets/is-valid', { qrcode: qrcode.toLowerCase() })
        .then((response) => {
          const date = moment(response.data.t);
          this.form.warranty_number = response.data.fp;
          this.form.sold_on_local = date.format('DD.MM.YYYY');
        })
        .catch(error => this.$store.dispatch('HandleError', error))
        .finally(() => {
          this.scanQrCode.openModal = false;
        });
    },
    detectFp(fp) {
      if (!fp) {
        return;
      }
      this.$store.getters.axl.post('sales/api/sale/find-by-qr', { fp, id: this.$props.id })
        .then((response) => {
          const { sale } = response.data;
          if (sale) {
            this.afterDetectAction(sale);
            this.$store.dispatch('ShowInfo', 'Данные успешно найдены');
          }
        })
        .catch(error => this.$store.dispatch('HandleError', error))
        .finally(() => {
          this.scanQrCode.openModal = false;
        });
    },
    afterDetectAction(sale) {
      const { positions } = sale;
      this.form.warranty_number = sale.qrcode_fp;
      this.form.sold_on_local = sale.sold_on_local;

      if (positions.length > 0) {
        this.form.product_id = positions[0].product_id;
        this.form.category_id = positions[0].category_id;
        this.form.type_id = positions[0].group_id;
      }
    },
    stopQrScan(error) {
      this.$store.dispatch('ShowErrorMessage', error);
      this.scanQrCode.openModal = false;
    },
    prePrint() {
      this.isLoading = true;

      this.$store.dispatch('warranties/prePrint', { ...this.form, profile_id: this.user.profile_id })
        .then((res) => {
          const myWindow = window.open('', 'PrintWindow');
          myWindow.document.write(res);

          setTimeout(() => {
            myWindow.document.close();
            myWindow.focus();
            myWindow.print();
          }, 1000);
        }).finally(() => {
          this.isLoading = false;
        });
    },
    /** Проверка даты */
    checkDate(dateArr, mode) {
      let day = mode === 1 ? +dateArr[0] : +dateArr[2];
      let year = mode === 1 ? +dateArr[2] : +dateArr[0];
      let month = +dateArr[1];
      const Data = new Date();

      if (day < 1 || day > 31) {
        day = Data.getDate().toString();
      } else {
        day = day.toString();
      }

      if (month < 1 || month > 12) {
        month = (Data.getMonth() + 1).toString();
      } else {
        month = month.toString();
      }

      if (year < 2021 || year > 2025) {
        year = Data.getFullYear().toString();
      } else {
        year = year.toString();
      }

      return { day, month, year };
    },
    /**
     * Форматирование даты
     * @param date дата в формате YYYY-MM-DD
     */
    formatDate(date) {
      if (!date) return null;
      const { day, month, year } = this.checkDate(date.split('-'), 2);
      return `${day < 10 ? `0${day}` : day}.${month < 10 ? `0${month}` : month}.${year}`;
    },
    getDateFormString(str, mode = 1) {
      const { day, month, year } = this.checkDate(mode === 1 ? str.split('.') : str.split('-'), mode);
      return new Date(year, month - 1, day);
    },
    handleBlur(e) {
      const { value } = e.target;
      if (value) {
        const myDate = this.getDateFormString(value);
        const minDate = this.getDateFormString(this.minDate, 2);
        const maxDate = this.getDateFormString(this.maxDate, 2);
        if (myDate >= minDate && myDate <= maxDate) {
          this.form.sold_on_local = value;
          const [day, month, year] = value.split('.');
          this.date = `${year}-${month}-${day}`;
        } else {
          this.form.sold_on_local = this.formatDate(this.date);
        }
      }
    },
    /** Получить timestamp. */
    setUniqueId() {
      return (new Date()).getTime();
    },
    /**
     * Проверка типа документа.
     * @param photo {Object} объект документа.
     * @returns {*|boolean}
     */
    CheckPDF(photo) {
      if (photo.base64) {
        return (photo.base64.indexOf('/pdf;') !== -1);
      }
      if (photo.url) {
        return (photo.url.indexOf('.pdf') !== -1);
      }
      return false;
    },
    /**
     * Получение пути до файла.
     * @param photo объект документа.
     * @returns {*}
     */
    GetFilePath(photo) {
      if (photo.base64 || photo.url) {
        return photo.url ? photo.url : photo.base64;
      }
      return '';
    },
    /**
     * Добавление документа к покупке.
     * @param e эвент
     */
    OnFilePicked(file, name) {
      const app = this;
      if (file) {
        if (file.name.lastIndexOf('.') <= 0) {
          this.$data.form[name] = null;
          return;
        }

        const fr = new FileReader();
        fr.readAsDataURL(file);
        const doc = this.$data.form[name];

        fr.addEventListener('load', () => {
          doc.filename = null;
          doc.id = null;
          doc.base64 = fr.result;
          app.$forceUpdate();
        });
      } else {
        this.$data.form[name] = null;
      }
    },
    /** Установка предзагруженных значений при редактировании покупки. */
    setDataPreload(data) {
      const app = this;
      if (data) {
        app.form = {
          ...data,
        };
      }
    },
    /**
     * Метод добавления новой покупки.
     */
    onSubmit() {
      const app = this;
      app.isLoading = true;
      const url = (this.$props.id !== 'null')
        ? 'warranty/api/warranty/update'
        : 'warranty/api/warranty/create';
      if (app.valid || this.is_draft) {
        const data = {
          ...app.form,
          action_id: null,
          profile_id: app.user.profile_id,
          is_draft: this.is_draft,
          register_type: 'web',
        };

        if (this.$props.id !== 'null') {
          data.warranty_id = this.$props.id;
        }

        app.$store.getters.axl.post(url, data)
          .then(() => {
            const text = this.is_draft
              ? 'Черновик сохранён'
              : 'ГС успешно зарегистрирован';
            app.$router.push('/warranties/');
            app.$store.dispatch('ShowInfo', text);
          })
          .catch((error) => {
            app.$store.dispatch('HandleError', error);
          }).finally(() => {
            app.isLoading = false;
          });
      }
    },
    onSubmitDraft() {
      this.is_draft = true;
      this.onSubmit();
    },
    onSend() {
      if (this.$refs.feedbackForm.validate()) {
        this.onSubmit();
      } else {
        this.$store.dispatch('ShowInfo', 'Заполните необходимые поля или сохраните как черновик');
      }
    },
    setCameraError(error) {
      this.cameraError = !!error;
    },
    setImageFromCamera(file) {
      const data = {
        target: {
          files: [file],
        },
      };
      this.OnFilePicked(data, this.eventNameFile);
      this.openModal = false;
    },
    openFilePicker(name) {
      this.eventNameFile = name;
      if (!this.cameraError) {
        this.openModal = true;
      } else {
        const ref = this.$refs[name];
        if (ref) {
          ref.click();
        }
      }
    },
  },
  watch: {

    /** */
    // eslint-disable-next-line func-names
    'form.car_id': function (val) {
      if (this.form.car_model_id) {
        const elem = this.cars.find(el => +el.car_model_id === +this.form.car_model_id);
        if (+elem.car_id !== +val) {
          this.form.car_model_id = null;
        }
      }
    },
    // eslint-disable-next-line func-names
    'form.car_model_id': function (val) {
      if (!this.form.car_id) {
        const elem = this.cars.find(el => +el.car_model_id === +val);

        if (elem) {
          this.form.car_id = elem.car_id;
        }
      }
    },

    // eslint-disable-next-line func-names
    'form.warranty_number': function (val) {
      this.detectFp(val);
    },

    /** Вотчер для поиска города */
    /** Вотчеры для поиска продукта */
    /** Вотчер для форматирования установленной даты */
    date(val) {
      this.form.sold_on_local = val && this.formatDate(val);
    },
  },
  async mounted() {
    const app = this;
    await this.$store.dispatch('warranties/GetInfo');
    if (this.$props.id !== 'null') {
      await this.$store.dispatch('warranties/GetWarranty', {
        profile_id: this.user.profile_id,
        warranty_id: this.$props.id,
      })
        .then((data) => {
          app.setDataPreload(data.warranty);
        });
    }
  },
};
